import styled from 'styled-components/macro';
import ResponsiveContainer from '../ResponsiveContainer';

const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.primary};
  width: 100%;
  padding: 20px 0;
  margin-top: auto;
`;

const Container = styled(ResponsiveContainer)`
  display: block;
  color: ${p => p.theme.colors.white};
  font-size: 20px;
  text-align: center;
  line-height: 1.2;
`;

export { Wrapper, Container };
